import { Button, PageState } from '@deepdive-ui';

export default function NotFoundPage() {
  return (
    <PageState
      title="Page not found"
      description="The page you’re looking for doesn’t exist or has moved."
      actions={
        <Button hierarchy="secondary" href="/">
          Back to Overview
        </Button>
      }
    />
  );
}
